import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import {
  reverseDate,
} from "../../utils/commonFunctions";
import { CircularAvatar, Loader } from "../commons";
import CustomizedAvatar from "../commons/CircularAvatar/CustomizedAvatar";
import {
  BriefCase,
  IdBadge,
  InterviewStatusIcon,
  LoctionRedIcon,
  NoticeCalendarIcon,
} from "../../assets/images";
import { LoginResponseType } from "../../redux/auth/authTypes";
type AppProps = {
  toggle: () => void;
  isOpen: boolean;
  data: any;
  handleSubmitFeedback?: () => void;
  loginData: LoginResponseType;
  fetching: boolean;
  feedback: string;
  setFeedback: React.Dispatch<React.SetStateAction<string>>;
};

const CheckInFeedBackModal = ({
  toggle,
  isOpen,
  data,
  handleSubmitFeedback,
  loginData,
  fetching,
  feedback,
  setFeedback,
}: AppProps) => {
  return (
    <>
      {fetching ? (
        <Loader />
      ) : (
        <Modal
          centered
          isOpen={isOpen}
          toggle={toggle}
          size="xl"
          style={{ minWidth: "355px" }}
          backdrop="static"
        >
          <ModalHeader toggle={toggle}>Submit Check-In Feedback</ModalHeader>
          <ModalBody className="pl-2 pr-2" style={{ paddingLeft: "40px" }}>
            <div className="d-flex" style={{ justifyContent: "center" }}>
              <div style={{ width: "58%" }} className="pr-2">
                <>
                  <p className="feedBack-heading mb-1">Add Check-In Comments</p>
                  <textarea
                    onChange={(e: any) => {
                      setFeedback((prv: string) => e?.target?.value);
                    }}
                    style={{
                      height: "241px",
                      width: "90%",
                      resize: "none",
                      border: "1px solid #bfcbe1",
                      borderRadius: "4px",
                    }}
                    value={feedback}
                    disabled={data?.feedback?.length}
                  ></textarea>
                  <button
                    className="btn btn-primary mt-4"
                    onClick={(e) => {
                      handleSubmitFeedback && handleSubmitFeedback();
                      toggle();
                    }}
                    disabled={feedback?.length === 0 || data?.feedback?.length}
                  >
                    Submit Check-In Feedback
                  </button>
                </>
              </div>

              <div
                style={{
                  width: "38%",
                  height: "fit-content",
                  border: "solid 1px #bfcbe1",
                  borderRadius: "5px",
                }}
                className="mt-2"
              >
                <div
                  className="p-3"
                  style={{ fontSize: "13px", fontWeight: 600 }}
                >
                  Employee Profile
                </div>
                <hr className="m-0"></hr>
                <div className="p-3">
                  <div
                    className="d-flex align-items-center "
                    style={{ gap: "3%" }}
                  >
                    <CustomizedAvatar
                      name={`${data?.updated_by?.first_name} ${
                        data?.updated_by?.last_name
                          ? data?.updated_by?.last_name
                          : ""
                      }`}
                      image={
                        data?.updated_by?.profile_pic &&
                        data?.updated_by.profile_pic?.file_url
                      }
                      style={{ width: "75px", fontSize: "25px" }}
                    />
                    <div className="ml-2">
                      <p
                        style={{
                          margin: "0px",
                          color: "#262a44",
                          fontWeight: "500",
                          fontSize: "15px",
                        }}
                      >{`${data?.updated_by?.first_name} ${
                        data?.updated_by?.last_name
                          ? data?.updated_by?.last_name
                          : ""
                      }`}</p>
                      <p
                        style={{
                          margin: "0px",
                          fontSize: "13px",
                          color: "#6e7491",
                        }}
                      >
                        {data?.updated_by?.job_title}
                      </p>
                      <p
                        style={{
                          margin: "0px",
                          fontSize: "13px",
                          color: "#6e7491",
                        }}
                      >
                        {data?.updated_by?.department}
                      </p>
                    </div>
                    {/* <div>
                      <div>
                        <p
                          className="mb-1"
                          style={{ fontSize: "15px", fontWeight: 600 }}
                        >
                          {data?.applicant_details?.name}
                        </p>
                        <p className="mt-0 mb-1" style={{ color: "#6e7491" }}>
                          {data?.applicant_details?.email}
                        </p>
                        <div className="mt-0 mb-1" style={{ color: "#6e7491" }}>
                          {data?.applicant_details?.phone_number}
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>

                <div className="inside-card-header d-flex w-100 p-3">
                  <div
                    className="feedBack-heading d-flex align-items-center"
                    style={{ width: "50%" }}
                  >
                    <img src={IdBadge} alt="" className="mr-3" />
                    <div>Employee ID</div>
                  </div>

                  <div style={{ width: "50%" }}>
                    {data?.updated_by?.employee_id ? (
                      <span className="sent">
                        {data?.updated_by?.employee_id}
                      </span>
                    ) : (
                      "NA"
                    )}
                  </div>
                </div>

                <div className="inside-card-header d-flex w-100 p-3">
                  <div
                    className="feedBack-heading d-flex align-items-center"
                    style={{ width: "50%" }}
                  >
                    <img src={BriefCase} alt="" className="mr-3" />
                    <div>Reporting To</div>
                  </div>
                  <div style={{ width: "50%" }}>
                    <div className="d-flex align-items-center">
                      <div>
                        <CircularAvatar
                          name={`${data?.manager?.first_name} ${data?.manager?.last_name}`}
                          image={
                            data?.manager?.profile_pic &&
                            data?.manager.profile_pic?.file_url
                          }
                        />
                      </div>
                      <span className="ml-2">
                        {`${data?.manager?.first_name} ${data?.manager?.last_name}`}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="inside-card-header d-flex w-100 p-3">
                  <div
                    className="feedBack-heading d-flex align-items-center"
                    style={{ width: "50%" }}
                  >
                    <img src={NoticeCalendarIcon} alt="" className="mr-3" />
                    <div>Joining Date</div>
                  </div>
                  <div style={{ width: "50%" }}>
                    {data?.updated_by?.start_date
                      ? reverseDate(data?.updated_by?.start_date?.split("T")[0])
                      : "NA"}
                  </div>
                </div>
                <div className="inside-card-header d-flex w-100 p-3">
                  <span
                    className="feedBack-heading d-flex align-items-center"
                    style={{ width: "50%" }}
                  >
                    <img src={LoctionRedIcon} alt="" className="mr-3" />
                    <div>Job Location</div>
                  </span>
                  <div style={{ width: "50%" }}>
                    {data?.updated_by?.branch_name
                      ? data?.updated_by?.branch_name
                      : "NA"}
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
      )}
    </>
  );
};

export default CheckInFeedBackModal;
